
export default [
  {
    path:"/bidStake",
    meta: {
      title: "bidStake",
      icon: "",
    },
    component: () => import('@/views/bidStake/index'),
  }


]
